import { Frequency } from '../../tamalelibs/models/emaildigest.model';
export const dialogConstants = {
    onWeeklyList: [
        {
            id: 'SUN',
            value: 'Sun',
            selected: false,
        },
        {
            id: 'MON',
            value: 'Mon',
            selected: false,
        },
        {
            id: 'TUE',
            value: 'Tue',
            selected: false,
        },
        {
            id: 'WED',
            value: 'Wed',
            selected: false,
        },
        {
            id: 'THU',
            value: 'Thu',
            selected: false,
        },
        {
            id: 'FRI',
            value: 'Fri',
            selected: false,
        },
        {
            id: 'SAT',
            value: 'Sat',
            selected: false,
        },
    ],
    onMonthlyList1: [
        {
            id: 'day',
            value: 'Day',
        },
        {
            id: 'day:L',
            value: 'Last Day',
        },
        {
            id: '1',
            value: 'First',
        },
        {
            id: '2',
            value: 'Second',
        },
        {
            id: '3',
            value: 'Third',
        },
        {
            id: '4',
            value: 'Fourth',
        },
        {
            id: 'L',
            value: 'Last',
        },
    ],
    frequencyList: [
        {
            id: Frequency.MONTHLY,
            value: 'Monthly',
        },
        {
            id: Frequency.WEEKLY,
            value: 'Weekly',
        },
        {
            id: Frequency.DAILY,
            value: 'Daily',
        }
    ],
    monthlyEvery: [
        {
            id: 1,
            value: '1',
        },
        {
            id: 2,
            value: '2',
        },
        {
            id: 3,
            value: '3',
        },
        {
            id: 6,
            value: '6',
        }
    ],
    weeklyEvery: [
        {
            id: 1,
            value: '1',
        },
        {
            id: 2,
            value: '2',
        },
        {
            id: 3,
            value: '3',
        },
        {
            id: 4,
            value: '4',
        }
    ],
    onMonthlyDayList: [
        {
            id: '1',
            value: '1',
        },
        {
            id: '2',
            value: '2',
        },
        {
            id: '3',
            value: '3',
        },
        {
            id: '4',
            value: '4',
        },
        {
            id: '5',
            value: '5',
        },
        {
            id: '6',
            value: '6',
        },
        {
            id: '7',
            value: '7',
        },
        {
            id: '8',
            value: '8',
        },
        {
            id: '9',
            value: '9',
        },
        {
            id: '10',
            value: '10',
        },
        {
            id: '11',
            value: '11',
        },
        {
            id: '12',
            value: '12',
        },
        {
            id: '13',
            value: '13',
        },
        {
            id: '14',
            value: '14',
        },
        {
            id: '15',
            value: '15',
        },
        {
            id: '16',
            value: '16',
        },
        {
            id: '17',
            value: '17',
        },
        {
            id: '18',
            value: '18',
        },
        {
            id: '19',
            value: '19',
        },
        {
            id: '20',
            value: '20',
        },
        {
            id: '21',
            value: '21',
        },
        {
            id: '22',
            value: '22',
        },
        {
            id: '23',
            value: '23',
        },
        {
            id: '24',
            value: '24',
        },
        {
            id: '25',
            value: '25',
        },
        {
            id: '26',
            value: '26',
        },
        {
            id: '27',
            value: '27',
        },
        {
            id: '28',
            value: '28',
        },
        {
            id: '29',
            value: '29',
        },
        {
            id: '30',
            value: '30',
        },
        {
            id: '31',
            value: '31',
        }
    ],
    onMonthlyXList: [
        {
            id: '1',
            value: 'Sunday',
        },
        {
            id: '2',
            value: 'Monday',
        },
        {
            id: '3',
            value: 'Tuesday',
        },
        {
            id: '4',
            value: 'Wednesday',
        },
        {
            id: '5',
            value: 'Thursday',
        },
        {
            id: '6',
            value: 'Friday',
        },
        {
            id: '7',
            value: 'Saturday',
        },
    ]
};
